(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('imageGallery', function(imageService, $timeout) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            model: '=',
            enableReviews: '@',
            showReviews: '&'
        },
        templateUrl: 'partials/hotels/imagegallery',
        link(scope, el, attrs) {
            scope.isPrerender = /prerender/i.test(navigator.userAgent);
            //need to do this as type of the original property gets changed back to text later (by angular we suspect)
            scope.reviewsEnabled = scope.enableReviews === 'true' && TRPCONFIG.Domain.ReviewsEnabled;
            scope.images = [];

            const itemCarousel = el.find('.large-gallery');
            const thumbCarousel = el.find('.thumb-list');
            const thumbH = 68;
            const thumbW = 68;
            const mainH = 480;
            const mainW = 870;
            const cms = attrs.cms === 'true';

            const cancel = scope.$watch('model', function(v) {
                if (!v) {
                    return;
                }

                cancel();

                const cmsImageUrls = scope.model.CmsImageUrls;

                if (cms) {
                    scope.images = v;
                } else if (cmsImageUrls) {
                    _.forEach(cmsImageUrls, i => {
                        scope.images.push({
                            altText: '',
                            thumbUrl: i,
                            mainUrl: i,
                            backgroundImage: { 'background-image': `url('${i}')` }
                        });
                    });
                } else {
                    const { model } = scope;
                    const { Title = '', Location = '', Province = '', Country = '' } = model;

                    const altText = `${Title}${Title && ', '}${Location}${Location && ', '}${Province}${Province && ', '}${Country}${Country && ', '}`;

                    const { NumberOfPhotos } = scope.model;
                    for (let i = 0; i < NumberOfPhotos; i++) {
                        const thumbUrl = imageService.getImageUrl(scope.model.Id, thumbW, thumbH, i, true);
                        const mainUrl = imageService.getImageUrl(scope.model.Id, mainW, mainH, i, false);
                        scope.images.push({
                            altText: `${altText}${i + 1}`,
                            thumbUrl,
                            mainUrl,
                            backgroundImage: { 'background-image': `url('${thumbUrl}')` }
                        });
                    }
                }

                $timeout(initCarousel);
            });

            // checkWidths function has been added to solve an issue on the product card gallery whereby, when coming back from the Room page, the first product card image appears broken and doesn't load. This code get the initial styles and width on the first load and saves them for use later on in the fix.
            function checkWidths() {
                let hotelListings = document.querySelectorAll('.hotel-listing');
                let slickTrack = document.querySelectorAll('.gallery-slides .slick-track');
                let originalStylesArr = [];
                let originalImageWidthArr = [];

                if (slickTrack.length === hotelListings.length) {
                    for (let i = 0; i < slickTrack.length; i++) {
                        let style = slickTrack[i].getAttribute('style');
                        if (slickTrack[i] && slickTrack[i].querySelectorAll('.slick-active img')) {
                            let slickWidth = slickTrack[i].querySelectorAll('.slick-active img')[0].width;
                            originalStylesArr.push(style);
                            originalImageWidthArr.push(slickWidth);
                        }
                    }

                    let imgMaxWidth = Math.max(...originalImageWidthArr);
                    let slickActive = document.querySelectorAll('.gallery-slides .slick-track .slick-slide');

                    if (!TRPCONFIG.Domain2.SlickTrackWidth) {
                        TRPCONFIG.Domain2.SlickTrackWidth = originalStylesArr[0];
                    }

                    if (!TRPCONFIG.Domain2.SlickTrackImgWidth) {
                        TRPCONFIG.Domain2.SlickTrackImgWidth = imgMaxWidth;
                    }

                    for (let i = 0; i < slickActive.length; i++) {
                        let width = imgMaxWidth;

                        if (width === 0) {
                            width = TRPCONFIG.Domain2.SlickTrackImgWidth;
                        }

                        slickActive[i].style = `width: ${width}px`;
                    }

                    if (slickTrack && slickTrack[0] && originalStylesArr[0] !== TRPCONFIG.Domain2.SlickTrackWidth) {
                        slickTrack[0].style = TRPCONFIG.Domain2.SlickTrackWidth;
                    }
                }
            }

            function initCarousel() {
                // slick is dumb and won't clone enough slides to fill the whole container
                // https://github.com/kenwheeler/slick/issues/1207
                const imgCount = scope.images.length;

                itemCarousel.slick({
                    rtl: TRPCONFIG.Rtl,
                    asNavFor: thumbCarousel,
                    speed: 500,
                    prevArrow: el.find('.stage .slick-prev'),
                    nextArrow: el.find('.stage .slick-next'),
                    infinite: imgCount > 5
                });

                itemCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    scope.selected = nextSlide;
                    scope.$apply();
                });

                // we need to remove 1 slide so the infinite carousel looks infinite
                const minSlidesToShow = imgCount > 1 ? imgCount - 1 : imgCount;

                thumbCarousel.slick({
                    rtl: TRPCONFIG.Rtl,
                    asNavFor: itemCarousel,
                    infinite: imgCount > 5,
                    centerMode: true,
                    focusOnSelect: true,
                    slidesToShow: minSlidesToShow,
                    swipeToSlide: true,
                    variableWidth: true
                });

                scope.$on('$destroy', function() {
                    itemCarousel.slick('unslick');
                    thumbCarousel.slick('unslick');
                });

                checkWidths();

                window.addEventListener('resize', function() {
                    TRPCONFIG.Domain2.SlickTrackWidth = '';
                    TRPCONFIG.Domain2.SlickTrackImgWidth = '';
                    checkWidths();
                });
            }
        }
    };
});
})();
